export default {
    path: "contact-us-enquiries",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "",
        name: "Contact Us Enquiries",
        meta: {
          requiresAuth: true,
        },
        component: () => import("@/views/contactUsEnquiry/contactEnquiry.vue"),
      },
    ],
  };
  